import IconButton from '@/_application/core/components/ui/icon-button';
import {Image} from '@/_application/core/components/ui/image';
import HighlightCategoriesMobileLoader from '@/_application/core/components/ui/loaders/highlight-categories-mobile-loader';
import {Swiper, SwiperSlide} from '@/_application/core/components/ui/slider';
import {ArrowNextIcon} from '@/_application/icons/arrow-next';
import {getSolidIconHighlightCategory} from '@/_application/modules/categories/utils/icon';
import {useHighlightCategories} from '@/framework/highlight-categories';
import rangeMap from '@/lib/range-map';
import {useTranslation} from 'next-i18next';
import {Scrollbar} from 'swiper/modules';
import {convertUrlToNewSite} from '@/_application/core/utils/convert-url';
import Link from '@/_application/core/components/ui/link';
import {convertArrayToMultidimensional} from '@/_application/core/utils/convert-array-to-multidimensional';

const NUMBER_ROWS_CATEGORIES = 2;

const PopularCatalog = () => {
    const {t} = useTranslation();
    const {highlightCategories, loading} = useHighlightCategories();

    const filteredCategories = highlightCategories.filter(icon => icon?.url);

    const newIconsList = convertArrayToMultidimensional(filteredCategories, NUMBER_ROWS_CATEGORIES);

    return (
        <div className="my-4 w-full">
            <div className="mx-4 flex flex-col content-center justify-center rounded-2xl bg-white shadow-2xl">
                <div className="mt-3 flex content-center items-center justify-center gap-1.5">
                    <p className="text-base font-bold text-primary">
                        {t('text-popupar-categories', 'Danh mục nổi bật')}
                    </p>
                    <ArrowNextIcon className="h-2.5 w-2.5 text-primary" />
                </div>

                <div className="popular-catelog-mobile mx-4 mt-6">
                    <Swiper
                        slidesPerView={4.5}
                        scrollbar={{
                            el: '.swiper-scrollbar',
                        }}
                        className={highlightCategories.length < 9 ? 'pb-6!' : 'mb-4 pb-6!'}
                        modules={[Scrollbar]}>
                        {loading ? (
                            <div className="grid h-50 grid-cols-4">
                                {rangeMap(8, i => (
                                    <HighlightCategoriesMobileLoader key={i} />
                                ))}
                            </div>
                        ) : (
                            newIconsList.map(iconArray => {
                                const [firstPosition, secondPosition] = iconArray;
                                const firstPositionImage = getSolidIconHighlightCategory(firstPosition!) ?? '';
                                const secondPositionImage = getSolidIconHighlightCategory(secondPosition!) ?? '';

                                const firstPositionUrl = firstPosition?.url
                                    ? convertUrlToNewSite(firstPosition.url)
                                    : '/';
                                const secondPositionUrl = secondPosition?.url
                                    ? convertUrlToNewSite(secondPosition.url)
                                    : '/';

                                return (
                                    <SwiperSlide key={firstPosition?.name} className="h-full">
                                        <div className={`flex flex-col`}>
                                            <Link href={firstPositionUrl}>
                                                <IconButton
                                                    whileTap={{scale: 0.9, opacity: 0.7}}
                                                    className="flex flex-col content-center items-center justify-start!"
                                                    icon={
                                                        <span className="h-9">
                                                            <Image
                                                                src={firstPositionImage}
                                                                alt={`${firstPosition?.name} icon`}
                                                                width={34}
                                                                height={34}
                                                                className="h-9 w-auto"
                                                            />
                                                        </span>
                                                    }
                                                    label={firstPosition?.name ?? undefined}
                                                    labelClassName="mt-3 line-clamp-2 w-[3.9rem] text-center text-sm"
                                                />
                                            </Link>

                                            {secondPosition && (
                                                <Link href={secondPositionUrl}>
                                                    <IconButton
                                                        whileTap={{scale: 0.9, opacity: 0.7}}
                                                        className="mt-4 flex flex-col content-center items-center justify-start!"
                                                        icon={
                                                            <span className="h-9">
                                                                <Image
                                                                    src={secondPositionImage}
                                                                    alt={`${firstPosition?.name} icon`}
                                                                    width={34}
                                                                    height={34}
                                                                    className="h-9 w-auto"
                                                                />
                                                            </span>
                                                        }
                                                        label={secondPosition?.name ?? undefined}
                                                        labelClassName="mt-3 line-clamp-2 w-[3.9rem] text-center text-sm"
                                                    />
                                                </Link>
                                            )}
                                        </div>
                                    </SwiperSlide>
                                );
                            })
                        )}
                        <div className="swiper-scrollbar"></div>
                    </Swiper>
                </div>
            </div>
        </div>
    );
};

export default PopularCatalog;
